import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ac3b8fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ac3b8fe&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=6ac3b8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3b8fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,Dropdown: require('/app/components/global/dropdown.vue').default,Search: require('/app/components/global/search.vue').default,VSidebar: require('/app/components/global/v-sidebar.vue').default,CommentsFilterModal: require('/app/components/comments/commentsFilterModal.vue').default,CBtn: require('/app/components/ui/button/c-btn.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
